import { Wrap, WrapItem } from "@chakra-ui/react";
import { MotionBox as Box, blogFadeIn } from "utils/motion";
import Button from "components/base/Button";
import Trans from "components/base/Trans";

const TAG_SORT_ORDER = {
  events: 200,
  "journey-to-hx50": 150,
  "hx50-blueprint": 3,
};

export default function TagFilter({ allAvailableTags, selectedTags, onTagClick }) {
  if (!allAvailableTags || allAvailableTags.length === 0) {
    return null;
  }

  return (
    <Box mb={[4, null, 8]} variants={blogFadeIn}>
      <Wrap spacing={2}>
        {[...allAvailableTags]
          .sort((a, b) => {
            const priorityA = TAG_SORT_ORDER[a.value] || 99;
            const priorityB = TAG_SORT_ORDER[b.value] || 99;
            return priorityA - priorityB;
          })
          .map((tag) => (
            <WrapItem key={tag.value}>
              <Button
                variant="tag"
                selected={selectedTags.includes(tag.value)}
                onClick={() => onTagClick(tag.value)}
              >
                {tag.label}
              </Button>
            </WrapItem>
          ))}
      </Wrap>
    </Box>
  );
}
